import React from 'react';

export default function Section({ children, className = '', bg = 'bg-dc-bg', id }) {
  return (
    <section id={id} className={`py-20 md:py-28 lg:py-32 ${bg} ${className}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {children}
      </div>
    </section>
  );
}